import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UserStoreEffects } from '@core-lib/store/user-store/effects';
import { userStoreReducer } from '@core-lib/store/user-store/reducer';
import { FeatureName } from '@core-lib/store/user-store/feature';

@NgModule({
	imports: [CommonModule, StoreModule.forFeature(FeatureName, userStoreReducer), EffectsModule.forFeature([UserStoreEffects])]
})
export class UserStoreModule {}
